import { render, staticRenderFns } from "./AusuariosActivosx.vue?vue&type=template&id=a1d498b8"
import script from "./AusuariosActivosx.vue?vue&type=script&lang=js"
export * from "./AusuariosActivosx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports